import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Check, Tv } from 'lucide-react';
import { SortableRankingList } from './SortableSeriesList';

export function RankNewSeriesDialog({ 
  open, 
  onClose, 
  newSeries,
  allSeries,
  onSaveOrder
}) {
  const [orderedSeries, setOrderedSeries] = React.useState([]);
  
  React.useEffect(() => {
    if (open && allSeries) {
      setOrderedSeries([...allSeries]);
    }
  }, [open, allSeries]);
  
  const handleReorder = (newOrder) => {
    setOrderedSeries(newOrder);
  };
  
  const handleSave = () => {
    onSaveOrder(orderedSeries.map(s => s.tmdb_id));
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[80vh]" data-testid="rank-new-series-dialog">
        <DialogHeader>
          <DialogTitle className="font-outfit text-[#3D4F6F]">
            Rank Your Priority
          </DialogTitle>
          <DialogDescription className="text-[#64748B]">
            Drag <span className="font-semibold text-[#F87171]">{newSeries?.title}</span> to set your viewing priority.
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4 max-h-[400px] overflow-y-auto">
          <SortableRankingList
            items={orderedSeries}
            onReorder={handleReorder}
            highlightId={newSeries?.tmdb_id}
          />
        </div>
        
        <DialogFooter className="gap-2">
          <Button 
            variant="ghost" 
            onClick={onClose}
            className="rounded-full"
          >
            Skip
          </Button>
          <Button 
            data-testid="save-rank-btn"
            onClick={handleSave}
            className="bg-[#F87171] hover:bg-[#EF4444] text-white rounded-full"
          >
            <Check className="w-4 h-4 mr-2" />
            Save Order
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
